module.exports = __webpack_public_path__ + "img/tg-blue.43d32204.svg";